import { Router } from '@angular/router';
import { DATA_SERVICE_TOKEN, IData, IDataService } from '../services/data/data-service.interfaces';
import { Observable, of, throwError } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { catchError, mergeMap, take } from 'rxjs/operators';

@Injectable()
export class DataResolverService  {
  constructor(@Inject(DATA_SERVICE_TOKEN) private dataService: IDataService, private router: Router) {}

  resolve(): Observable<IData> | Observable<never> {
    return this.dataService.getDataFromServer().pipe(
      take(1),
      mergeMap((data) => (data ? of(data) : throwError('no data'))),
      catchError(() => {
        localStorage.removeItem('token');
        this.router.navigate(['/']);
        return of(null);
      })
    );
  }
}
